export const SDL_EDITOR_ID = 'sdl';
